import { render, staticRenderFns } from "./ItemLocations.vue?vue&type=template&id=83fc64ce&scoped=true"
import script from "./ItemLocations.vue?vue&type=script&lang=js"
export * from "./ItemLocations.vue?vue&type=script&lang=js"
import style0 from "./ItemLocations.vue?vue&type=style&index=0&id=83fc64ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fc64ce",
  null
  
)

export default component.exports